module.exports = __webpack_public_path__ + "img/qrCode_cfdb5.png";